export default __webpack_public_path__ + "static/media/marketplace.fb05e460.png";